import React from 'react';
import Uganda_s6 from './uganda_s6';
import Uganda_s6_subjects from './uganda_s6_subjects';
const Uganda_s6fre = () => {
  return (
    <div>
      <Uganda_s6 />
    <Uganda_s6_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>French</h1>
      <h3>Economics in the new secondary school curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_s6fre;